import script from "./help-center.vue?vue&type=script&setup=true&lang=ts"
export * from "./help-center.vue?vue&type=script&setup=true&lang=ts"

import "./help-center.vue?vue&type=style&index=0&id=180b9d0c&lang=scss"
import "./help-center.vue?vue&type=style&index=1&id=180b9d0c&scoped=true&lang=scss"

import exportComponent from "D:\\NewLODAPC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180b9d0c"]])

export default __exports__